var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4013 12.002H9.6013C5.33464 12.002 2.66797 14.6686 2.66797 18.9353V22.3886C2.66797 26.6686 5.33464 29.3353 9.6013 29.3353H22.388C26.6546 29.3353 29.3213 26.6686 29.3213 22.402V18.9353C29.3346 14.6686 26.668 12.002 22.4013 12.002Z",
    fill: "#1080FF",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1718 7.42854L16.7052 2.96188C16.3185 2.57521 15.6785 2.57521 15.2918 2.96188L10.8252 7.42854C10.4385 7.81521 10.4385 8.45521 10.8252 8.84188C11.2118 9.22854 11.8518 9.22854 12.2385 8.84188L14.9985 6.08187V20.3352C14.9985 20.8819 15.4518 21.3352 15.9985 21.3352C16.5452 21.3352 16.9985 20.8819 16.9985 20.3352V6.08187L19.7585 8.84188C19.9585 9.04188 20.2118 9.13521 20.4652 9.13521C20.7185 9.13521 20.9718 9.04188 21.1718 8.84188C21.5718 8.45521 21.5718 7.82854 21.1718 7.42854Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.018e351747b8a7a077c51609fe3f8750.svg";
export { ForwardRef as ReactComponent };